export const Config = {
    COMMON_URL: process.env.REACT_APP_COMMON_URL,
    COMMON_AUTH_URL: process.env.REACT_APP_COMMON_AUTH_URL,
    COMMON_API_URL: process.env.REACT_APP_COMMON_API_URL,
    WEBSOCKET_URL: process.env.REACT_APP_WEBSOCKET_URL,
    SIG_KEY: process.env.REACT_APP_SIG_KEY,
    VERSION: '20.05.1-1'
};
